import messages from './messages';
import { StateProgramSetup } from '../StateProgramSetup';
import PropertyStateConfig from '../../../PropertyStateConfig';

const BONDSetup = ({
  editMode,
  onChange,
  values,
  promptToaster,
  isLoadingPassbookRateData,
  state,
  stateConfigs,
}: Props) => {
  const bondConfig = {
    programName: 'BOND',
    titleMessage: messages.title,
    showInterimCerts: true,
    showOverrideQualification: true,
    showAnnualRecertMonth: true,
  };

  return (
    <>
      <StateProgramSetup
        editMode={editMode}
        onChange={onChange}
        values={values}
        promptToaster={promptToaster}
        isLoadingPassbookRateData={isLoadingPassbookRateData}
        config={bondConfig}
      />

      <PropertyStateConfig
        editMode={editMode}
        onChange={onChange}
        state={state}
        stateConfigs={stateConfigs}
        affordableProgramName={bondConfig.programName}
      />
    </>
  );
};

export default BONDSetup;
